import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "grid wide",
  id: "probeGrid",
  style: {"margin-bottom":"24px"}
}
const _hoisted_2 = { class: "flex col g0" }
const _hoisted_3 = { class: "text-muted f12 bold" }
const _hoisted_4 = { class: "text-muted f10" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = { class: "flex align-center" }
const _hoisted_7 = {
  style: {"white-space":"nowrap"},
  class: "text-muted bold"
}
const _hoisted_8 = {
  key: 0,
  class: "flex align-center g4"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: "/ico/battery_full.svg" }, null, -1)
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = {
  key: 0,
  class: "indicator green tooltip"
}
const _hoisted_12 = {
  key: 1,
  class: "indicator red tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WideCard = _resolveComponent("WideCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.probes, (probe) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: probe.probeUID
      }, [
        (probe.active || _ctx.unactives)
          ? (_openBlock(), _createBlock(_component_WideCard, {
              key: 0,
              active: probe.active,
              icon: "/ico/probe-blue.svg",
              title: probe.name,
              onClick: ($event: any) => (_ctx.onProbeClick(probe))
            }, {
              subtitle: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getStoreName(probe)), 1),
                  _createElementVNode("span", _hoisted_4, "Dernière remontée : " + _toDisplayString(probe.getProbeLastTimestamp()), 1)
                ])
              ]),
              body: _withCtx(() => []),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(probe.getProbeLastTemperature()), 1)
                  ]),
                  (probe.lastTemperature != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("span", _hoisted_10, _toDisplayString(probe.batteryLevel) + "%", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (probe.isProbeWorking())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12))
              ]),
              _: 2
            }, 1032, ["active", "title", "onClick"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}